import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AgrupamentosService {

  baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient
  ) { }

  listarAgrupamento(){
    const url = `${this.baseUrl}listarAgrupamentos`;
    return this.http.get(url);
  }

  cadastrarAgrupamento(agrupamento: any){
    const url = `${this.baseUrl}cadastrarAgrupamento`;
    return this.http.post<any>(url, agrupamento);
  }

  listaAgrupamentoPorId(idAgrupamento: number){
    const url = `${this.baseUrl}listaAgrupamento/${idAgrupamento}`
    return this.http.get(url)
  }

  atualizarAgrupamento(agrupamento: any, idAgrupamento:any) {
    const url = `${this.baseUrl}atualizarAgrupamento/${idAgrupamento}`;
    return this.http.put<any>(url, agrupamento);
  }

  deletarAgrupamento(idAgrupamento:number){
    const url = `${this.baseUrl}deletarAgrupamento/${idAgrupamento}`;
    return this.http.delete<any>(url);
  }

  listarAgrupamentoUsuario(idUsuario:any) {
    const url = `${this.baseUrl}listarAgrupamentos/usuario/${idUsuario}`;
    return this.http.get(url);
  }

}
